/**
 * What a tap steers the next conversation at: a pattern from the hub, a
 * word from its detail (word-practice §7), or a book just finished, from the
 * reader's Talk about it (storybooks phase 2 §3). One at a time — the server
 * refuses any two.
 */
export type PractiseTarget = { practiceItemId: string } | { vocabularyItemId: string } | { storyBookId: string };

/** `startSession`'s input for a tap, kept out of `usePractise` so it can be tested without React. */
export function startInput(learnerId: string, target: PractiseTarget) {
  return { learnerId, mode: 'FREE_CHAT' as const, ...target };
}
